import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

export default function VerifyEmailPrompt() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || 'your email';

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex flex-col p-4">
      <div className="flex-1 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-6">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-10 h-10" style={{ color: '#0E60C6' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Verifica la tua Email</h2>
          <p className="text-gray-600 mb-6">
            Registrazione completata con successo!
          </p>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700 mb-3">
            Abbiamo inviato un link di verifica a:
          </p>
          <p className="font-semibold text-gray-900 mb-3">{email}</p>
          <p className="text-sm text-gray-600">
            Clicca sul link nell'email per verificare il tuo account e completare la registrazione.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/login')}
            className="w-full text-white py-2 rounded-lg transition font-medium"
            style={{ backgroundColor: '#0E60C6' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0B4FA3'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0E60C6'}
          >
            Vai al Login
          </button>

          <p className="text-sm text-center text-gray-600">
             Se non vedi la mail, controlla la cartella spam/indesiderata, oppure{' '}
             <button className="font-medium" style={{ color: '#0E60C6' }}>
               invia di nuovo
             </button>
           </p>
        </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
